
<div class="page-header">
  <div>
    <h1>Meu dashboard</h1>
    <p>
      Bem-vindo ao painel de acompanhamento dos seus usuários.
    </p>
  </div>

  <a
    class="btn btn-primary"
    routerLink="/parceiro/usuarios"
  >
    Gerenciar usuários →
  </a>
</div>


<!-- ESTATÍSTICAS -->
<div class="stats-grid">

  <div class="card">
    <div class="stat-label">
      Usuários vinculados
    </div>

    <div class="stat-value">
      {{ usuarios.length }}
    </div>
  </div>

  <div class="card">
    <div class="stat-label">
      Usuários com plano
    </div>

    <div class="stat-value">
      {{ ativos.length }}
    </div>
  </div>

</div>

<!-- USUÁRIOS RECENTES -->
<div class="card recent-users">

  <h3>Usuários recentes</h3>

  <div *ngIf="loading" class="loading-state">
    Carregando usuários...
  </div>

  <ng-container *ngIf="!loading">

    <div
      class="table-container"
      *ngIf="usuarios.length > 0"
    >
      <table>
        <thead>
        <tr>
          <th>Nome</th>
          <th>Telefone</th>
          <th>Plano</th>
        </tr>
        </thead>

        <tbody>
        <tr *ngFor="let u of usuarios.slice(0, 6)">
          <td>{{ u.nome }}</td>
          <td>{{ u.telefone || '—' }}</td>

          <td>
              <span
                class="plan-badge"
                [class.no-plan]="!u.plano"
              >
                {{ u.plano || 'Sem plano' }}
              </span>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <p
      *ngIf="!usuarios.length && !erro"
      class="empty-state"
    >
      Nenhum usuário vinculado.
    </p>

  </ng-container>

</div>
